export default __webpack_public_path__ + "static/media/login-thumbnail.078b2949.png";